import React from 'react'
import style from './empty-group.module.scss'
import EmptyIcon from '../../../../../../../assets/svg/solo-chat/empty-group.svg'

type Props = {
 add: () => void
 canCreate: boolean
}

export function EmptyGroup(props: Props) {
 return (
  <div className={style.emptyGroup}>
    <div className={style.content}>
      <img src={EmptyIcon} alt="empty"/>
      <p>You haven't added any data labelling group for this intent</p>
      {props.canCreate && <button onClick={props.add}>Add Now</button>}
    </div>
  </div>
 )
}
